export const BookWithMeModuleName = "kUHJ2d";
export default {BookWithMeModuleName};